export default ({next}) => {
  const isAuthenticated = localStorage.getItem('access_token') !== null

  if (!isAuthenticated) {
    return next({ name: 'login' })
  }

  return next()
}
